/**
 * Which fill routine handles which official PDF.
 *
 * The CMS "PDF form" node names a file under public/forms; this registry maps
 * that file name to the module that knows how to fill it. Adding a bank means
 * adding its spec + fill under src/forms/<bank>/ and one line here.
 */

import { fillForm1076 } from "@/forms/fannie-mae-1076/fill";
import { PDF_FILE as FANNIE_1076 } from "@/forms/fannie-mae-1076/spec.mjs";
import { fillMidAmerica } from "@/forms/mid-america-condo-2-4/fill";
import { PDF_FILE as MID_AMERICA } from "@/forms/mid-america-condo-2-4/spec.mjs";
import { fillPcb } from "@/forms/pcb-full-review/fill";
import { PDF_FILE as PCB } from "@/forms/pcb-full-review/spec.mjs";

export interface FormFillReport {
  text: number;
  boxes: number;
  problems: string[];
}

export type FormFiller = (
  answers: Record<string, string | null | undefined>,
  context: Record<string, string | null | undefined>,
  options: { pdfBytes?: ArrayBuffer | Uint8Array; pdfUrl?: string; flatten?: boolean },
) => Promise<{ bytes: Uint8Array; report: FormFillReport }>;

const FILLERS: Record<string, FormFiller> = {
  [FANNIE_1076]: fillForm1076,
  [MID_AMERICA]: fillMidAmerica,
  [PCB]: fillPcb,
};

/** The filler for a PDF file name, or a clear error naming what is missing. */
export function fillerFor(pdfFile: string): FormFiller {
  const filler = FILLERS[pdfFile];
  if (!filler) {
    throw new Error(
      `No fill routine is registered for "${pdfFile}". ` +
        `Known forms: ${Object.keys(FILLERS).join(", ")}. ` +
        `Register it in src/forms/registry.ts.`,
    );
  }
  return filler;
}
